import React from 'react';
import { Countdown } from './Countdown';
import { CTAButton } from './CTAButton';
import { plans, footerTrust } from '../data/content';
export function FinalCta() {
  return <section className="w-full bg-ink-800 px-4 py-14 sm:px-5 sm:py-20" data-id="element-65" data-mp="19ez3lioa9i4t">
      <div className="mx-auto max-w-4xl text-center" data-id="element-66" data-mp="19ga2b42vfzp2">
        <h2 className="text-2xl font-extrabold uppercase leading-tight text-white sm:text-4xl" data-id="element-67" data-mp="15d40q9qpewox">
          💰 Última oportunidad al precio de lanzamiento
        </h2>

        <p className="mt-8 text-xs font-extrabold uppercase tracking-[0.2em] text-gray-300" data-id="element-68" data-mp="1ee1wy5uwhzwy">
          ⏰ El precio cierra en:
        </p>
        <div className="mt-5" data-id="element-69" data-mp="1t1wp9l4zy29i">
          <Countdown data-id="element-70" data-mp="1t251rbx7j5k6" />
        </div>

        <div className="mt-10 grid gap-6 md:grid-cols-2" data-id="element-71" data-mp="1o43lszv2vmcx">
          {plans.map(plan => <article key={plan.name} className={`flex flex-col rounded-3xl border p-6 text-left sm:p-7 ${plan.featured ? 'border-brand-500 bg-ink-900 shadow-[0_0_45px_rgba(249,115,22,0.25)]' : 'border-white/10 bg-ink-900'}`} style={{
          width: "330px"
        }} data-id="element-72" data-mp="223mi8vej199e">
              <span aria-hidden="true" className="text-2xl" data-id="element-73" data-mp="n75m5roz2d34">
                {plan.icon}
              </span>
              <h3 className="mt-3 text-base font-extrabold text-white sm:text-lg" data-id="element-74" data-mp="s4xrbnemnvp9">
                {plan.shortName}
              </h3>
              <p className="mt-2 text-sm text-gray-400" data-id="element-75" data-mp="122v9pu9t2y9y">{plan.finalIncludes}</p>
              <p className="mt-6 text-sm font-semibold text-gray-500 line-through" data-id="element-76" data-mp="120ilizdgfrog">
                {plan.oldPrice}
              </p>
              <p className="text-3xl font-extrabold text-brand-500 sm:text-4xl" data-id="element-77" data-mp="1b31kv9i17m5y">
                {plan.price}
              </p>
              <div className="mt-auto pt-7" data-id="element-78" data-mp="1fvkyg6gpyhar">
                <CTAButton href={plan.href} variant={plan.featured ? 'primary' : 'outline'} data-id="element-79" data-mp="1ktd2tzyjvvvu">
                  {plan.cta}
                </CTAButton>
              </div>
            </article>)}
        </div>

        <ul className="mt-10 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-[11px] text-gray-400 sm:gap-x-6 sm:text-sm" data-id="element-80" data-mp="1ttrncx3ox6ya">
          {footerTrust.map(item => <li key={item} data-id="element-81" data-mp="3qsb60wrk21ml">{item}</li>)}
        </ul>
      </div>
    </section>;
}